// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WorkDirection_body__rfeNi {
  display: flex;
  flex-direction: column;
  margin-top: 98rem;
  width: 100%;
}
@media (min-width: 1921px) {
  .WorkDirection_body__rfeNi {
    padding-left: max((100vw - 1968px) / 2, 0);
    padding-right: max((100vw - 1968px) / 2, 0);
  }
}
@media only screen and (max-width: 700px) {
  .WorkDirection_body__rfeNi {
    margin-top: 86rem;
  }
}
.WorkDirection_body__rfeNi .WorkDirection_header__hTUle {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 16px;
  margin: 0 auto;
  width: 100%;
  padding: 0 48px;
}
@media (min-width: 1825px) {
  .WorkDirection_body__rfeNi .WorkDirection_header__hTUle {
    width: 1856px;
  }
}
@media only screen and (max-width: 700px) {
  .WorkDirection_body__rfeNi .WorkDirection_header__hTUle {
    padding: 0 16rem;
  }
}
.WorkDirection_body__rfeNi .WorkDirection_header__hTUle .WorkDirection_title__kpjY0 {
  display: inline;
  gap: 24rem;
  font-family: "Vivl Rail", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 72rem;
  line-height: 82rem;
  color: #1d2939;
}
.WorkDirection_body__rfeNi .WorkDirection_header__hTUle .WorkDirection_title__kpjY0 img {
  height: 68rem;
  width: 68rem;
  margin-right: 12rem;
}
@media only screen and (max-width: 700px) {
  .WorkDirection_body__rfeNi .WorkDirection_header__hTUle .WorkDirection_title__kpjY0 img {
    height: 42rem;
    width: 42rem;
  }
}
@media only screen and (max-width: 700px) {
  .WorkDirection_body__rfeNi .WorkDirection_header__hTUle .WorkDirection_title__kpjY0 {
    font-family: "Vivl Rail", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 32rem;
    line-height: 42rem;
    color: #1d2939;
  }
}
.WorkDirection_body__rfeNi .WorkDirection_container__M-CDl {
  scrollbar-width: none;
  height: fit-content;
  display: flex;
  overflow-x: auto;
  gap: 24rem;
  margin-top: 32rem;
  padding: 0 48rem;
}
@media (min-width: 1825px) {
  .WorkDirection_body__rfeNi .WorkDirection_container__M-CDl {
    padding: 0 calc((100vw - 1824px) / 2);
  }
}
@media only screen and (max-width: 700px) {
  .WorkDirection_body__rfeNi .WorkDirection_container__M-CDl {
    margin-top: 16rem;
    gap: 16rem;
    padding: 0 16rem;
  }
}
.WorkDirection_body__rfeNi .WorkDirection_container__M-CDl .WorkDirection_element__qTnaF {
  position: relative;
  flex: none;
  width: 100%;
  max-width: 522rem;
  display: flex;
  flex-direction: column;
  border-radius: 8rem;
  padding: 38rem 42rem;
  background-color: #ffffff;
  overflow: hidden;
}
@media only screen and (max-width: 700px) {
  .WorkDirection_body__rfeNi .WorkDirection_container__M-CDl .WorkDirection_element__qTnaF {
    padding: 24rem;
  }
}
@media only screen and (max-width: 700px) {
  .WorkDirection_body__rfeNi .WorkDirection_container__M-CDl .WorkDirection_element__qTnaF {
    max-width: 300rem;
  }
}
.WorkDirection_body__rfeNi .WorkDirection_container__M-CDl .WorkDirection_element__qTnaF .WorkDirection_backgroundPattern__3MegH {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: auto;
  z-index: 1;
}
.WorkDirection_body__rfeNi .WorkDirection_container__M-CDl .WorkDirection_element__qTnaF .WorkDirection_imageWorkDir__vI3Op {
  position: absolute;
  top: 14rem;
  right: 14rem;
  width: 54rem;
  height: 54rem;
  overflow: hidden;
  border-radius: 32rem;
  z-index: 1;
}
@media only screen and (max-width: 700px) {
  .WorkDirection_body__rfeNi .WorkDirection_container__M-CDl .WorkDirection_element__qTnaF .WorkDirection_imageWorkDir__vI3Op {
    width: 300rem;
    height: 168rem;
    border-radius: 16rem;
  }
}
.WorkDirection_body__rfeNi .WorkDirection_container__M-CDl .WorkDirection_element__qTnaF .WorkDirection_infoWorkDir__SeuGF {
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1 1;
  gap: 8rem;
  z-index: 2;
}
.WorkDirection_body__rfeNi .WorkDirection_container__M-CDl .WorkDirection_element__qTnaF .WorkDirection_infoWorkDir__SeuGF .WorkDirection_title__kpjY0 {
  width: fit-content;
  height: auto;
  white-space: normal;
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 32rem;
  line-height: 42rem;
  color: #1d2939;
}
@media only screen and (max-width: 700px) {
  .WorkDirection_body__rfeNi .WorkDirection_container__M-CDl .WorkDirection_element__qTnaF .WorkDirection_infoWorkDir__SeuGF .WorkDirection_title__kpjY0 {
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 22rem;
    line-height: 24rem;
    color: #1d2939;
  }
}
.WorkDirection_body__rfeNi .WorkDirection_container__M-CDl .WorkDirection_element__qTnaF .WorkDirection_infoWorkDir__SeuGF .WorkDirection_description__uL\\+ZX {
  display: flex;
  flex-direction: column;
  width: 100%;
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16rem;
  line-height: 24rem;
  color: #1d2939;
}
.WorkDirection_body__rfeNi .WorkDirection_container__M-CDl .WorkDirection_element__qTnaF .WorkDirection_infoWorkDir__SeuGF .WorkDirection_description__uL\\+ZX * {
  margin: 0 0 16px;
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16rem;
  line-height: 24rem;
  color: #1d2939;
}
.WorkDirection_body__rfeNi .WorkDirection_container__M-CDl .WorkDirection_element__qTnaF .WorkDirection_infoWorkDir__SeuGF .WorkDirection_description__uL\\+ZX h2, .WorkDirection_body__rfeNi .WorkDirection_container__M-CDl .WorkDirection_element__qTnaF .WorkDirection_infoWorkDir__SeuGF .WorkDirection_description__uL\\+ZX h3 {
  margin: 0 0 2px;
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 20rem;
  line-height: 26rem;
  color: #1d2939;
}
.WorkDirection_body__rfeNi .WorkDirection_container__M-CDl .WorkDirection_element__qTnaF .WorkDirection_infoWorkDir__SeuGF .WorkDirection_description__uL\\+ZX ul {
  padding-left: 24rem;
}
.WorkDirection_body__rfeNi .WorkDirection_container__M-CDl .WorkDirection_element__qTnaF .WorkDirection_infoWorkDir__SeuGF .WorkDirection_description__uL\\+ZX li {
  margin: 0;
}
.WorkDirection_body__rfeNi .WorkDirection_container__M-CDl .WorkDirection_element__qTnaF .WorkDirection_infoWorkDir__SeuGF .WorkDirection_description__uL\\+ZX li::marker {
  left: 0;
}
.WorkDirection_body__rfeNi .WorkDirection_container__M-CDl .WorkDirection_element__qTnaF .WorkDirection_controlPanel__7Ctog {
  position: relative;
  display: flex;
  width: 100%;
  gap: 8rem;
  z-index: 2;
  margin-top: 24rem;
}
@media only screen and (max-width: 700px) {
  .WorkDirection_body__rfeNi .WorkDirection_container__M-CDl .WorkDirection_element__qTnaF .WorkDirection_controlPanel__7Ctog {
    flex-direction: column;
  }
}
.WorkDirection_body__rfeNi .WorkDirection_container__M-CDl .WorkDirection_element__qTnaF .WorkDirection_controlPanel__7Ctog .WorkDirection_Button__LkUSO {
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
  padding: 12rem;
  gap: 8rem;
  border: 1px solid #eaecf0;
  border-radius: 10rem;
  background-color: #ffffff;
  transition: 0.2s ease-in-out;
  cursor: pointer;
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16rem;
  line-height: 20rem;
  color: #1d2939;
}
.WorkDirection_body__rfeNi .WorkDirection_container__M-CDl .WorkDirection_element__qTnaF .WorkDirection_controlPanel__7Ctog .WorkDirection_Button__LkUSO:hover {
  background-color: #fcfcfd;
}
.WorkDirection_body__rfeNi .WorkDirection_container__M-CDl .WorkDirection_element__qTnaF .WorkDirection_controlPanel__7Ctog .WorkDirection_ButtonIcon__1kaoU {
  display: block;
  height: 20rem;
  width: 20rem;
}
.WorkDirection_body__rfeNi .WorkDirection_scrollButtonContainer__PJowG {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: end;
  height: fit-content;
  width: fit-content;
  gap: 16rem;
}
@media only screen and (max-width: 700px) {
  .WorkDirection_body__rfeNi .WorkDirection_scrollButtonContainer__PJowG {
    display: none;
  }
}

.WorkDirection_container__M-CDl::-webkit-scrollbar {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/components/WorkDirection/ui/WorkDirection.module.scss","webpack://./src/styles/_mixins.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,WAAA;AAFF;AAIE;EANF;IAOI,0CAAA;IACA,2CAAA;EADF;AACF;AC+HE;EDvIF;IAYI,iBAAA;EAAF;AACF;AAEE;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,SAAA;ECSF,cDR8B;ECS9B,WAAA;EACA,eAAA;ADRF;ACSE;EDhBA;ICiBE,aAAA;EDNF;AACF;AC4GE;EDxHA;ICqBE,gBAAA;EDLF;AACF;AAXI;ECkCF,eAAA;EACA,UAAA;EAxDA,oCCHW;EDIX,kBAAA;EACA,gBAkEgC;EAjEhC,gBAAA;EACA,kBAAA;EACA,cCKS;AFgCX;ACgBE;EACE,aAAA;EACA,YAAA;EACA,mBAAA;ADdJ;ACwFE;EA7EA;IAKI,aAAA;IACA,YAAA;EDZJ;AACF;ACkFE;EDlHE;ICrBF,oCCHW;IDIX,kBAAA;IACA,gBAoEkC;IAnElC,gBAAA;IACA,kBAAA;IACA,cCKS;EFoDT;AACF;AApCE;EACE,qBAAA;EACA,mBAAA;ECpBF,aAAA;EACA,gBAAA;EAEA,UAAA;EACA,iBAAA;EACA,gBAAA;AD0DF;ACxDE;EDWA;ICVE,qCAAA;ED2DF;AACF;AC0DE;ED5GA;ICNE,iBAAA;IACA,UAAA;IACA,gBAAA;ED4DF;AACF;AApDI;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,yBERE;EFSF,gBAAA;AAsDN;ACuCE;EDvGE;IAaI,cAAA;EAuDN;AACF;ACkCE;EDvGE;IAiBI,iBAAA;EAwDN;AACF;AAtDM;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AAwDR;AArDM;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,oBAAA;EACA,UAAA;AAuDR;ACWE;ED1EI;IAWI,aAAA;IACA,cAAA;IACA,oBAAA;EAwDR;AACF;AArDM;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;AAuDR;AArDQ;EACE,kBAAA;EACA,YAAA;EACA,mBAAA;ECzFR,iCCFU;EDGV,kBAAA;EACA,gBDyFwC;ECxFxC,gBAAA;EACA,kBAAA;EACA,cCKS;AF4IX;ACfE;EDjDM;ICtFN,iCCFU;IDGV,kBAAA;IACA,gBD4F0C;IC3F1C,gBAAA;IACA,kBAAA;IACA,cCKS;EFqJT;AACF;AA9DQ;EACE,aAAA;EACA,sBAAA;EACA,WAAA;ECrGR,iCCFU;EDGV,kBAAA;EACA,gBAH0D;EAI1D,gBAAA;EACA,kBAAA;EACA,cCKS;AFiKX;AApEU;EACE,gBAAA;ECxGV,iCCFU;EDGV,kBAAA;EACA,gBAH0D;EAI1D,gBAAA;EACA,kBAAA;EACA,cCKS;AF0KX;AAzEU;EACE,eAAA;EC5GV,iCCFU;EDGV,kBAAA;EACA,gBD2G0C;EC1G1C,gBAAA;EACA,kBAAA;EACA,cCKS;AFmLX;AA9EU;EACE,mBAAA;AAgFZ;AA9EU;EACE,SAAA;AAgFZ;AA/EY;EACE,OAAA;AAiFd;AA3EM;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,iBAAA;AA6ER;ACvEE;EDZI;IAQI,sBAAA;EA+ER;AACF;AA9EQ;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,SAAA;EACA,yBAAA;EACA,oBAAA;EACA,yBE7GF;EF8GE,4BAAA;EACA,eAAA;EChJR,iCCFU;EDGV,kBAAA;EACA,gBD+IwC;EC9IxC,gBAAA;EACA,kBAAA;EACA,cCKS;AF4NX;AApFU;EACE,yBElJF;AFwOV;AAlFQ;EACE,cAAA;EACA,aAAA;EACA,YAAA;AAoFV;AA9EE;ECvHA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;ADwMF;AChHE;EDyBA;IC9GE,aAAA;EDyMF;AACF;;AAtFA;EACE,aAAA;AAyFF","sourcesContent":["@use \"/src/styles/mixins\" as *;\n@use \"/src/styles/variables\" as *;\n\n.body {\n  display: flex;\n  flex-direction: column;\n  margin-top: 98rem;\n  width: 100%;\n\n  @media (min-width: 1921px) {\n    padding-left: max(calc((100vw - 1968px) / 2), 0);\n    padding-right: max(calc((100vw - 1968px) / 2), 0);\n  }\n\n  @include mobile {\n    margin-top: 86rem;\n  }\n\n  .header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-end;\n    gap: 16px;\n    @include container($margin: 0 auto);\n    .title {\n      @include sectionHeader;\n    }\n  }\n\n\n  .container {\n    scrollbar-width: none;\n    height: fit-content;\n    @include scrollable;\n\n    .element {\n      position: relative;\n      flex: none;\n      width: 100%;\n      max-width: 522rem;\n      display: flex;\n      flex-direction: column;\n      border-radius: 8rem;\n      padding: 38rem 42rem;\n      background-color: $white;\n      overflow: hidden;\n\n      @include mobile {\n        padding: 24rem;\n      }\n\n      @include mobile {\n        max-width: 300rem;\n      }\n\n      .backgroundPattern {\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        width: 100%;\n        height: auto;\n        z-index: 1;\n      }\n\n      .imageWorkDir {\n        position: absolute;\n        top: 14rem;\n        right: 14rem;\n        width: 54rem;\n        height: 54rem;\n        overflow: hidden;\n        border-radius: 32rem;\n        z-index: 1;\n\n        @include mobile {\n          width: 300rem;\n          height: 168rem;\n          border-radius: 16rem;\n        }\n      }\n\n      .infoWorkDir {\n        position: relative;\n        display: flex;\n        flex-direction: column;\n        flex: 1;\n        gap: 8rem;\n        z-index: 2;\n\n        .title {\n          width: fit-content;\n          height: auto;\n          white-space: normal;\n\n          @include fnt(32, 42, $gray-800, 600);\n\n          @include mobile {\n            @include fnt(22, 24, $gray-800, 600);\n          }\n        }\n\n        .description {\n          display: flex;\n          flex-direction: column;\n          width: 100%;\n          @include fnt(16, 24, $gray-800);\n          & * {\n            margin: 0 0 16px;\n            @include fnt(16, 24, $gray-800);\n          }\n          h2, h3 {\n            margin: 0 0 2px;\n            @include fnt(20, 26, $gray-800, 600)\n          }\n          ul {\n            padding-left: 24rem;\n          }\n          li {\n            margin: 0;\n            &::marker {\n              left: 0;\n            }\n          }\n        }\n      }\n\n      .controlPanel {\n        position: relative;\n        display: flex;\n        width: 100%;\n        gap: 8rem;\n        z-index: 2;\n        margin-top: 24rem;\n        @include mobile {\n          flex-direction: column;\n        }\n        .Button {\n          display: flex;\n          flex-grow: 1;\n          align-items: center;\n          justify-content: center;\n          padding: 12rem;\n          gap: 8rem;\n          border: 1px solid $gray-200;\n          border-radius: 10rem;\n          background-color: $white;\n          transition: .2s ease-in-out;\n          cursor: pointer;\n          @include fnt(16, 20, $gray-800, 600);\n          &:hover {\n            background-color: $gray-25;\n          }\n\n        }\n        .ButtonIcon {\n          display: block;\n          height: 20rem;\n          width: 20rem;\n        }\n      }\n    }\n  }\n\n  .scrollButtonContainer {\n    @include scrollButtonContainer;\n  }\n}\n\n\n.container::-webkit-scrollbar {\n  display: none;\n}","@use \"variables\" as *;\n\n@mixin fnt($size: 16, $height: 24, $color: $black, $weight: 400, $font: $font-text, $unit: \"rem\") {\n  font-family: $font;\n  font-style: normal;\n  font-weight: $weight;\n  font-size: #{$size}#{$unit};\n  line-height: #{$height}#{$unit};\n  color: $color;\n}\n\n@mixin scrollable {\n  display: flex;\n  overflow-x: auto;\n\n  gap: 24rem;\n  margin-top: 32rem;\n  padding: 0 48rem;\n\n  @media(min-width: #{$main-container + 1}px) {\n    padding: 0 calc((100vw - #{$main-container}px) / 2);\n  }\n\n  @include mobile {\n    margin-top: 16rem;\n    gap: 16rem;\n    padding: 0 16rem;\n  }\n}\n\n@mixin container($margin: 124rem auto) {\n  margin: $margin;\n  width: 100%;\n  padding: 0 48px;\n  @media (min-width: #{$main-container + 1}px) {\n    width: #{$main-container + 32}px;\n\n  }\n  @include mobile {\n    padding: 0 16rem;\n  }\n}\n\n@mixin scrollButtonContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-end;\n  justify-content: end;\n  height: fit-content;\n  width: fit-content;\n  gap: 16rem;\n\n  @include mobile {\n    display: none;\n  }\n}\n\n@mixin sectionHeader {\n  display: inline;\n  gap: 24rem;\n\n  img {\n    height: 68rem;\n    width: 68rem;\n    margin-right: 12rem;\n    @include mobile {\n      height: 42rem;\n      width: 42rem;\n    }\n  }\n\n  @include fnt(72, 82, $gray-800, 400, $font-title);\n  @include mobile {\n    @include fnt(32, 42, $gray-800, 400, $font-title);\n  }\n}\n\n@mixin header {\n  width: 100%;\n  padding: 0 48rem;\n  height: fit-content;\n  @include sectionHeader;\n  @include mobile {\n    padding: 0 16rem;\n  }\n  @content\n}\n\n@mixin textToMobile {\n  @include fnt(20, 24, $gray-400, 400, $font-text);\n  @include mobile {\n    @include fnt(16, 20, $gray-400, 400, $font-text);\n  }\n}\n\n@mixin inputField {\n  border-radius: 12rem;\n  padding: 16rem 20rem;\n\n  background-color: $white;\n  border: 1px $gray-300 solid;\n\n  @include mobile {\n    padding: 12rem 16rem;\n  }\n\n  @include textToMobile;\n\n  &::placeholder {\n    @include textToMobile;\n  }\n\n  * {\n    @include textToMobile;\n  }\n\n  &:active {\n    border: 1px $gray-700, solid;\n  }\n\n  &:hover {\n    border: 1px $gray-400, solid;\n  }\n\n  &error {\n    @include fnt(16, 24, $error-300, 500, $font-text);\n    @include mobile {\n      @include fnt(12, 24, $error-300, 500, $font-text);\n    }\n    border: 1px $error-500, solid;\n\n    * {\n      color: $error-300;\n    }\n  }\n}\n\n@mixin mobile {\n  @media only screen and (max-width: #{$mobile-width}px) {\n    @content;\n  }\n}\n\n@mixin laptop {\n  @media only screen and (max-width: #{$laptop-width}px) {\n    @content;\n  }\n}\n\n@mixin tablet {\n  @media only screen and (max-width: #{$tablet-width}px) {\n    @content;\n  }\n}\n\n@mixin hd {\n  @media only screen and (max-width: #{$hd-width}px) {\n    @content;\n  }\n}\n\n@mixin hd-plus {\n  @media only screen and (min-width: #{$hd-width}px) {\n    @content;\n  }\n}","$font-title: \"Vivl Rail\", sans-serif;\n$font-text: \"Roboto\", sans-serif;\n\n$gray-20: #f9f9fa;\n$gray-25: #fcfcfd;\n$gray-50: #f9fafb;\n$gray-100: #f2f4f7;\n$gray-200: #eaecf0;\n$gray-300: #d0d5dd;\n$gray-400: #98a2b3;\n$gray-500: #667085;\n$gray-600: #475467;\n$gray-700: #344054;\n$gray-800: #1d2939;\n$gray-900: #101828;\n$gray-950: #0C111D;\n\n$main: #47C4F0;\n\n$error-50: #FEF3F2;\n$error-100: #FEE4E2;\n$error-200: #FECDCA;\n$error-300: #FDA29B;\n$error-400: #F97066;\n$error-500: #F04438;\n$error-600: #D92D20;\n\n$green: #17B26A;\n$red: #F04438;\n$orange: #F79009;\n\n$success: $green;\n$error: $red;\n$warning: $orange;\n\n$black: $gray-900;\n$white: #ffffff;\n$text-gray: $gray-500;\n$text-color: #2c2d2e;\n$text-color-secondary: $text-gray;\n$border: $gray-300;\n\n$mobile-width: 700;\n$tablet-width: 1024;\n$laptop-width: 1440;\n$hd: 1680;\n$hd-width: 1920;\n\n$main-container: 1824;\n\n$tr: 0.2s ease-out;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"body": `WorkDirection_body__rfeNi`,
	"header": `WorkDirection_header__hTUle`,
	"title": `WorkDirection_title__kpjY0`,
	"container": `WorkDirection_container__M-CDl`,
	"element": `WorkDirection_element__qTnaF`,
	"backgroundPattern": `WorkDirection_backgroundPattern__3MegH`,
	"imageWorkDir": `WorkDirection_imageWorkDir__vI3Op`,
	"infoWorkDir": `WorkDirection_infoWorkDir__SeuGF`,
	"description": `WorkDirection_description__uL+ZX`,
	"controlPanel": `WorkDirection_controlPanel__7Ctog`,
	"Button": `WorkDirection_Button__LkUSO`,
	"ButtonIcon": `WorkDirection_ButtonIcon__1kaoU`,
	"scrollButtonContainer": `WorkDirection_scrollButtonContainer__PJowG`
};
export default ___CSS_LOADER_EXPORT___;
